import { selectUser } from '../state/userSlice';
import { useSelector } from 'react-redux';

const useUser = () => useSelector(selectUser);

export default useUser;
